import React from "react";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";

const FullscreenControl = ({ isFullScreen, onToggleFullScreen }) => (
  <button
    onClick={onToggleFullScreen}
    className="transition"
    aria-label="Toggle fullscreen"
  >
    {isFullScreen ? <MdFullscreenExit size={18} /> : <MdFullscreen size={18} />}
  </button>
);

export default FullscreenControl;
